<script setup lang="ts">
import { provide } from "vue"
import { useLayoutStore } from "@/Stores/layout"
import ScreenWarning from "@/Components/Utils/ScreenWarning.vue"
import Notification from '@/Components/Utils/Notification.vue'

provide('layout', useLayoutStore())

const layout = useLayoutStore()
</script>

<template>
    <ScreenWarning v-if="layout.app.environment === 'staging'" />

    <div class="min-h-screen w-screen bg-gradient-to-br from-slate-900 via-sky-950 to-slate-900 flex items-center justify-center p-4">

        <!-- Decorative blobs -->
        <div class="pointer-events-none absolute inset-0 overflow-hidden">
            <div class="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-sky-500/10 blur-3xl" />
            <div class="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-sky-400/10 blur-3xl" />
        </div>

        <div class="relative w-full max-w-md">
            <!-- Brand header -->
            <div class="mb-4 text-center">
                <h1 class="text-2xl font-bold text-white tracking-tight mb-4">Repro App</h1>
                <div class="inline-flex items-center justify-center w-auto  mb-4 p-2 bg-white rounded-sm shadow-lg shadow-red-500/20">
                    <img src="/logo-kr-transparent.webp" alt="Repro App Logo" class="h-16 object-contain" />
                </div>
                <p class="italic mt-1 text-sm text-sky-300/70">Masuk untuk mengakses sistem</p>
            </div>

            <!-- Card -->
            <div class="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl px-8 py-8">
                <slot />
            </div>

            <!-- Footer -->
            <p class="mt-6 text-center text-xs text-slate-500">
                &copy; {{ new Date().getFullYear() }} Repro App. All rights reserved.
            </p>
        </div>
    </div>

    <!-- Global declaration: Notification -->
    <notifications
        dangerously-set-inner-html
        :max="3"
        width="500"
        classes="custom-style-notification"
        :pauseOnHover="true"
    >
        <template #body="props">
            <Notification :notification="props" />
        </template>
    </notifications>
</template>
